<template>
    <div class="column"><slot /></div>
</template>

<script>
export default {
    name: 'Column',
};
</script>

<style lang="less" scoped>
.column {
    min-width: 320px;
    max-width: 400px;

    &.pull-left,
    &.pull-right {
        max-width: 320px;
    }
}

@media (max-width: 740px) {
    .column {
        &.pull-left,
        &.pull-right {
            max-width: 400px;
        }
    }
}
</style>
